import { canEdit, IfAbility } from '@efdigital/ll-addon-auth';
import type { MediaImage } from '@efdigital/ll-addon-data';
import { Heading } from '@efdigital/ll-addon-ui';
import { ImageBrowser } from '@efdigital/ll-admin-v2/components/media/image-browser.gts';
import { LinkTo } from '@ember/routing';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class LibraryMediaImagesIndex extends Component {
  @service declare router: RouterService;

  onImageSelected = (image: MediaImage) => {
    this.router.transitionTo('library.media-images.edit', image.id!);
    return Promise.resolve();
  };

  <template>
    <div class="container py-5">
      <Heading
        @text="Image Library"
        @secondary="This is your image library. You can upload images here and use them across Xceed and Leadership Live."
      />

      <IfAbility @ability="library" @atLeast="viewer">
        <:if>
          <ImageBrowser @onImageSelected={{this.onImageSelected}}>
            <:item as |item|>
              <div class="col-md-4 col-xl-3">
                <div class="card h-100">
                  <img
                    src={{item.thumbnailUrl}}
                    alt={{item.alt}}
                    class="card-img-top object-fit-cover"
                  />
                  <div class="card-body">
                    <h3 class="card-title h5">
                      <LinkTo
                        @route="library.media-images.edit"
                        @model={{item.id}}
                        class="fw-bold stretched-link text-decoration-none"
                      >
                        {{item.title}}
                      </LinkTo>
                    </h3>
                    {{#if item.alt}}
                      <p class="card-text lh-sm">
                        {{item.alt}}
                      </p>
                    {{/if}}
                    {{#if item.keywords}}
                      <div class="mt-2">
                        <small class="text-muted visually-hidden"><strong
                          >Keywords:</strong></small>
                        <div class="d-flex flex-wrap gap-1 mt-1">
                          {{#each item.keywords as |keyword|}}
                            <span class="badge bg-secondary">{{keyword}}</span>
                          {{/each}}
                        </div>
                      </div>
                    {{/if}}
                  </div>
                </div>
              </div>
            </:item>
          </ImageBrowser>

          {{#if (canEdit "library")}}
            <div class="text-center">
              <LinkTo
                @route="library.media-images.upload"
                class="btn btn-primary btn-md"
              ><iconify-icon inline icon="ph:image-duotone" />
                Upload New Image</LinkTo>
            </div>
          {{/if}}
        </:if>
        <:else>
          <div class="alert alert-warning" role="alert">
            <h4 class="alert-heading">Access Denied</h4>
            <p>You do not have permission to view the media library.</p>
            <p class="mb-0">Please contact your administrator if you believe you
              should have access.</p>
          </div>
        </:else>
      </IfAbility>
    </div>
  </template>
}
